var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Subject, BehaviorSubject } from 'rxjs';
import { v1 as uuid } from 'uuid';
import { AppinfoService } from './appinfo.service';
import { CommonRequestService } from './common-request.service';
import { CommonTableService } from './common-table.service';
import { UserService } from './user.service';
import { SocketService, SocketLogs } from './socket.service';
import { AppSettings } from './../app.settings';
import { CommonFunctionService } from './common-function.service';
import { LayerService } from './layer.service';
import { ToastrService } from 'ngx-toastr';
import { AttrIndexService } from './attr-index.service';
import { AdminService } from './admin.service';
var LayerQcService = /** @class */ (function () {
    function LayerQcService(toastr, socketService, adminService, appinfoService, attrIndexService, requestService, tableService, layerService, userService, commonFuncService) {
        this.toastr = toastr;
        this.socketService = socketService;
        this.adminService = adminService;
        this.appinfoService = appinfoService;
        this.attrIndexService = attrIndexService;
        this.requestService = requestService;
        this.tableService = tableService;
        this.layerService = layerService;
        this.userService = userService;
        this.commonFuncService = commonFuncService;
        // Qc messages by processId
        this.qcLogs = new BehaviorSubject({});
        // Build Topo message by processId
        this.topoLogs = new BehaviorSubject({});
        //
        this.onQcFinish = new Subject();
        this.sortFilterByCount = function (a, b) {
            if (a.count && b.count) {
                return 0;
            }
            else if (a.count) {
                return -1;
            }
            else {
                return 1;
            }
        };
    }
    // Run QC for all the layers
    // Socket is used for receiving responses
    LayerQcService.prototype.qcLayers = function (layerIds, qcType, rules) {
        return __awaiter(this, void 0, void 0, function () {
            var longTransactionExist, url, userInfo, body, tempProcessId;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminService.checkLongTransactions()];
                    case 1:
                        longTransactionExist = _a.sent();
                        if (longTransactionExist) {
                            return [2 /*return*/];
                        }
                        url = AppSettings.serviceRootUrl + 'azgiv/qcLayers';
                        userInfo = this.userService.getUserInfo();
                        body = {
                            userSubscriptionId: userInfo.userSubId,
                            // customerId: this.userService.getCustomerIdByType(),
                            userId: userInfo.userId,
                            sessionId: this.appinfoService.getSessionUuid(),
                            layerIds: JSON.stringify(layerIds)
                            // stateCode: this.userService.getSelectedCustomerInfo('stateCode'),
                        };
                        if (rules && rules.length) {
                            body.qcRules = JSON.stringify(rules);
                        }
                        // if (layerIds) {
                        // 	body.layerIds = JSON.stringify(layerIds);
                        // }
                        if (qcType) {
                            body.qcType = qcType;
                        }
                        tempProcessId = uuid();
                        this.socketService.onInitProcess.next({
                            tempId: tempProcessId,
                            processType: 'QC'
                        });
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                _this.requestService.requestPost(url, body, function (rsp) {
                                    var processesById = _this.qcLogs.getValue();
                                    var processId = rsp.data.content;
                                    _this.socketService.onInitProcess.next({
                                        tempId: tempProcessId,
                                        processId: processId,
                                        processType: 'Upload'
                                    });
                                    var process = _this.socketService.registerProcessById(rsp.data.content, processesById);
                                    _this.qcLogs.next(processesById);
                                    resolve({
                                        processId: processId
                                    });
                                }, function (err) { return reject(err); });
                            })];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // async qcLayerContent(layerId, editFilter: QcEditFilter) {
    // 	const url = AppSettings.serviceRootUrl + 'azgiv/qcLayerContent';
    // 	const userInfo = this.userService.getUserInfo();
    // 	const body: any = {
    // 		userSubscriptionId: userInfo.userSubId,
    // 		layerId: layerId,
    // 		editFilter: JSON.stringify(editFilter)
    // 	};
    // 	return new Promise<any>((resolve, reject) => {
    // 		this.requestService.requestPost(url, body, rsp => {
    // 			resolve(rsp);
    // 		}, err => reject());
    // 	});
    // }
    // async qcLayerDomain(layerId, editFilter: QcEditFilter) {
    // 	const url = AppSettings.serviceRootUrl + 'azgiv/qcLayerDomain';
    // 	const userInfo = this.userService.getUserInfo();
    // 	const body: any = {
    // 		userSubscriptionId: userInfo.userSubId,
    // 		layerId: layerId,
    // 		editFilter: JSON.stringify(editFilter)
    // 	};
    // 	return new Promise<any>((resolve, reject) => {
    // 		this.requestService.requestPost(url, body, rsp => {
    // 			resolve(rsp);
    // 		}, err => reject());
    // 	});
    // }
    LayerQcService.prototype.qcLayersDynamic = function (editFilters) {
        return __awaiter(this, void 0, void 0, function () {
            var url, userInfo, body;
            var _this = this;
            return __generator(this, function (_a) {
                url = AppSettings.serviceRootUrl + 'azgiv/qcLayersDynamic';
                userInfo = this.userService.getUserInfo();
                body = {
                    userSubscriptionId: userInfo.userSubId,
                };
                // if (qcType) {
                // 	body.qcType = qcType
                // }
                if (editFilters) {
                    body.editFilters = JSON.stringify(editFilters);
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService.requestPost(url, body, function (rsp) {
                            resolve(rsp);
                        }, function (err) { return reject(); });
                    })];
            });
        });
    };
    LayerQcService.prototype.qcLayerIncNag = function (nctNames) {
        return __awaiter(this, void 0, void 0, function () {
            var url, userInfo, body;
            var _this = this;
            return __generator(this, function (_a) {
                url = AppSettings.serviceRootUrl + 'azgiv/qcLayerIncNag';
                userInfo = this.userService.getUserInfo();
                body = {
                    nctNames: JSON.stringify(nctNames),
                    userSubscriptionId: userInfo.userSubId
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService.requestPost(url, body, function (rsp) {
                            console.log('qcLayerIncNag results: ', rsp);
                            resolve(rsp);
                        }, function (err) { return reject(err); });
                    })];
            });
        });
    };
    // Get qc feature report
    LayerQcService.prototype.getQcFeatureReport = function (glyId, qaCodes, gfo, paging, sortColumns, model) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qcIntraLayerReport';
            var params = {
                glyId: glyId.toString(),
            };
            if (qaCodes && qaCodes.length) {
                params.qaCodes = JSON.stringify(qaCodes);
            }
            if (gfo) {
                params.gfo = JSON.stringify(gfo);
            }
            if (!paging) {
                paging = {
                    pageSize: _this.tableService.defaultTableConfig.pageSize
                };
            }
            else if (!paging.pageSize) {
                paging.pageSize = _this.tableService.defaultTableConfig.pageSize;
            }
            if (sortColumns && sortColumns.length) {
                params.sortColumns = JSON.stringify(sortColumns);
            }
            // model = model || 'N'; // TODO: remove this after Bo fix fishbone filter
            if (model) {
                params.model = model;
            }
            _this.requestService.setParamsPaging(params, paging);
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp);
            }, function (err) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    // await this.layerService.checkLayerNotFoundError(err, cusId, glyId);
                    reject(err);
                    return [2 /*return*/];
                });
            }); });
        });
    };
    // Get qc schema report
    LayerQcService.prototype.getQcSchemaReport = function (layerId, qaCodes, gfo) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var url = AppSettings.serviceRootUrl + 'azgiv/qcSchemaReport';
                        var params = {
                            layerId: layerId.toString()
                        };
                        if (qaCodes && qaCodes.length) {
                            params.qaCodes = JSON.stringify(qaCodes);
                        }
                        if (gfo) {
                            params.gfo = JSON.stringify(gfo);
                        }
                        _this.requestService.setParamsPaging(params, {
                            pageNumber: 1,
                            pageSize: 200,
                            rowCount: 0
                        });
                        _this.requestService.requestGet(url, {
                            params: params
                        }, function (rsp) {
                            resolve(rsp);
                        }, function (err) { return reject(err); });
                    })];
            });
        });
    };
    // Get qc layer report
    LayerQcService.prototype.getQcLayerReport = function (layerId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var url = AppSettings.serviceRootUrl + 'azgiv/qcLayerReport';
                        _this.requestService.requestGet(url, {
                            params: {
                                layerId: layerId
                            }
                        }, function (rsp) {
                            resolve(rsp);
                        }, function (err) { return reject(err); });
                    })];
            });
        });
    };
    LayerQcService.prototype.getQaRules = function (customerId, layerType, layerId, layerId1, layerId2, sortByProperty) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // resolve([]);
            // return;
            var url = AppSettings.serviceRootUrl + 'azgiv/qaRules';
            var params = {
            // customerId: customerId.toString()
            };
            if (layerId || layerId === 0) {
                params.layerId = layerId;
            }
            if (layerId1 || layerId1 === 0) {
                params.layerId1 = layerId1;
            }
            if (layerId2 || layerId2 === 0) {
                params.layerId2 = layerId2;
            }
            if (layerType) {
                params.interLayerReport = layerType;
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                var qaRules = [];
                if (rsp.data) {
                    rsp.data.forEach(function (d) {
                        qaRules.push({
                            code: d.gqr_cd,
                            describLong: d.gqr_desc_long,
                            errorLevel: d.gqr_err_level,
                            exceptionAllowed: d.gqr_exception,
                            count: d.cnt,
                            image: d.gqr_image,
                            scope: d.gqr_scope,
                            type: d.gqr_type,
                            ruleName: d.gqr_name
                        });
                    });
                    sortByProperty = sortByProperty || 'name';
                    qaRules.sort(function (a, b) {
                        if (a[sortByProperty] < b[sortByProperty]) {
                            return -1;
                        }
                        else if (a[sortByProperty] > b[sortByProperty]) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    });
                }
                resolve(qaRules);
            }, function (err) { return reject(err); });
        });
    };
    // Get all qa rules with detailed cause
    LayerQcService.prototype.getAllQaRulesWithDetail = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qaRules';
            _this.requestService.requestGet(url, {}, function (rsp) {
                var qaRules = [];
                if (rsp.data) {
                    rsp.data.forEach(function (d) {
                        qaRules.push({
                            code: d.gqr_cd,
                            causeFix: d.gqr_cause_fix,
                            fields: d.gqr_fields,
                            exception: d.gqr_exception
                            // describLong: d.gqr_desc_long,
                            // errorLevel: d.gqr_err_level,
                            // count: d.cnt,
                            // image: d.gqr_image,
                            // scope: d.gqr_scope,
                            // type: d.gqr_type,
                            // ruleName: d.gqr_name
                        });
                    });
                }
                _this.qaRuleDetails = qaRules;
                resolve(qaRules);
            }, function (err) { return reject(err); });
        });
    };
    LayerQcService.prototype.buildTopology = function (customerId, userId, userSubId, successCallback, errorCallback) {
        var _this = this;
        var url = AppSettings.serviceRootUrl + 'azgiv/topology';
        var body = {
            customerId: customerId,
            userId: userId,
            userSubscriptionId: userSubId,
            sessionId: this.appinfoService.getSessionUuid()
        };
        // fake a processId for the pop up logs dialogue window
        var tempProcessId = uuid();
        this.socketService.onInitProcess.next({
            tempId: tempProcessId,
            processType: 'TOPO'
        });
        this.requestService.requestPost(url, body, function (rsp) {
            var processesById = _this.topoLogs.getValue();
            _this.socketService.onInitProcess.next({
                tempId: tempProcessId,
                processId: rsp.data.content,
                processType: 'TOPO'
            });
            _this.socketService.registerProcessById(rsp.data.content, processesById);
            _this.qcLogs.next(processesById);
            // if (successCallback) {
            // 	successCallback(rsp);
            // }
        }, errorCallback);
    };
    LayerQcService.prototype.getQcFeatureReportQuery = function (glyId, qaCodes, gfo, includeGeom, model) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qcIntraLayerReportQuery';
            var params = {
                glyId: glyId.toString(),
                includeGeom: includeGeom
            };
            if (qaCodes && qaCodes.length) {
                params.qaCodes = JSON.stringify(qaCodes);
            }
            if (gfo) {
                params.gfo = JSON.stringify(gfo);
            }
            if (model) {
                params.model = model;
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp.data);
            }, function (err) { return reject(err); });
        });
    };
    // Get the qc error count for a layer
    LayerQcService.prototype.getQcErrorCount = function (layerId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qcErrorCount';
            _this.requestService.requestGet(url, {
                params: {
                    glyId: layerId
                }
            }, function (rsp) {
                resolve(rsp.data[0]);
            }, function (err) { return reject(err); });
        });
    };
    // Submit layer to parent agency
    LayerQcService.prototype.submitLayer = function (layer, parentEmails) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var url, body;
            return __generator(this, function (_a) {
                url = AppSettings.serviceRootUrl + 'azgiv/submitLayer';
                body = {
                    glyId: layer.id,
                    userSubscriptionId: this.userService.getUserInfo().userSubId,
                    layerName: layer.name,
                    definedBy: layer.category.definedBy,
                    category: layer.category.name,
                    email: parentEmails
                };
                this.requestService.requestPost(url, body, function (rsp) {
                    resolve(rsp);
                }, function (err) { return reject(err); });
                return [2 /*return*/];
            });
        }); });
    };
    LayerQcService.prototype.getSubmitStatus = function (layerId) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = AppSettings.serviceRootUrl + 'azgiv/submitStatus';
                this.requestService.requestGet(url, {
                    params: {
                        // customerId: this.userService.selectedCustomerId,
                        layerId: layerId
                    }
                }, function (rsp) { return resolve({
                    hasError: rsp.data.val,
                    msg: rsp.data.msg
                }); }, function (err) { return reject(err); });
                return [2 /*return*/];
            });
        }); });
    };
    LayerQcService.prototype.getQcCellClassName = function (colNotes, exceptionsByCol, colProp, qcFilterOptions) {
        var qcClass = '';
        // let isAllErrorsExcepted = false;
        // if (exceptionsByCol && exceptionsByCol[colProp]) {
        // 	isAllErrorsExcepted = !colNotes.find(i => !exceptionsByCol[colProp][i.cd]);
        // }
        // if (isAllErrorsExcepted) {
        // 	qcClass = 'qc-exception-cell';
        // } else {
        if (exceptionsByCol && exceptionsByCol[colProp]) {
            if (!colNotes) {
                qcClass = 'qc-exception-cell';
                return qcClass;
            }
        }
        if (colNotes) {
            var featureOptions = qcFilterOptions.filter(function (o) { return colNotes.find(function (c) { return o.value === c.cd; }); });
            var errorLevels = featureOptions.map(function (o) { return o.errorLevel; });
            if (errorLevels.indexOf('CRITICAL') > -1) {
                qcClass = 'qc-error-cell';
            }
            else if (errorLevels.indexOf('WARNING') > -1) {
                qcClass = 'qc-warning-cell';
            }
        }
        // }
        return qcClass;
    };
    LayerQcService.prototype.getQcErrorLevelCellClassName = function (errorLevel) {
        var qcClass;
        if (errorLevel === 'CRITICAL') {
            qcClass = 'qc-error-cell';
        }
        else if (errorLevel === 'WARNING') {
            qcClass = 'qc-warning-cell';
        }
        return qcClass;
    };
    // Inter Layer
    // buildFishboneAnalysis(cusId, usbId) {
    // 	return new Promise<FishboneState>((resolve, reject) => {
    // 		const url = AppSettings.serviceRootUrl + 'azgiv/fishboneAnalysis';
    // 		this.requestService.requestPost(url, {
    // 			customerId: cusId,
    // 			userSubscriptionId: usbId,
    // 			sessionId: this.appinfoService.getSessionUuid()
    // 		}, (rsp: any) => {
    // 			console.log(rsp);
    // 		}, err => reject(err));
    // 	});
    // }
    LayerQcService.prototype.getFishboneState = function (customerId, model) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/fishboneState';
            var params = {
                customerId: customerId
            };
            if (model) {
                params.model = model;
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                var data = rsp.data;
                resolve({
                    id: data.state_id,
                    desc: data.state_desc,
                    layers: data.layers
                });
            }, function (err) { return reject(err); });
        });
    };
    // TODO: Remove the following services
    LayerQcService.prototype.getQcInterLayerReportByAttr = function (customerId, reportType, qaCodes, gfo, paging, sortColumns) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qcInterLayerReportByAttr';
            var params = {
                customerId: customerId,
                reportType: reportType
            };
            if (qaCodes) {
                params.qaCodes = JSON.stringify(qaCodes);
            }
            if (gfo) {
                params.gfo = JSON.stringify(gfo);
            }
            if (!paging) {
                paging = {
                    pageSize: _this.tableService.defaultTableConfig.pageSize
                };
            }
            else if (!paging.pageSize) {
                paging.pageSize = _this.tableService.defaultTableConfig.pageSize;
            }
            if (sortColumns && sortColumns.length) {
                params.sortColumns = JSON.stringify(sortColumns);
            }
            _this.requestService.setParamsPaging(params, paging);
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp);
            }, function (err) { return reject(err); });
        });
    };
    LayerQcService.prototype.getQcInterLayerReportByMap = function (customerId, reportType, bbox, qaCodes, gfo, sortColumns) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qcInterLayerReportByMap';
            var params = {
                customerId: customerId,
                reportType: reportType,
                bbox: JSON.stringify(bbox)
            };
            if (qaCodes) {
                params.qaCodes = JSON.stringify(qaCodes);
            }
            if (gfo) {
                params.gfo = JSON.stringify(gfo);
            }
            if (sortColumns && sortColumns.length) {
                params.sortColumns = JSON.stringify(sortColumns);
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                if (rsp && rsp.data) {
                    // Sort so that FSA/FSB will draw before FS1/FS3
                    rsp.data.sort(function (a, b) {
                        if (!b.qa_notes || !b.qa_notes.cd) {
                            return -1;
                        }
                        else if (!a.qa_note || !a.qa_notes.cd) {
                            return 1;
                        }
                        else {
                            if (a.qa_notes.cd < b.qa_notes.cd) {
                                return 1;
                            }
                            else if (a.qa_notes.cd > b.qa_notes.cd) {
                                return -1;
                            }
                            else {
                                return 0;
                            }
                        }
                    });
                }
                resolve(rsp);
            }, function (err) { return reject(err); });
        });
    };
    LayerQcService.prototype.getQcInterLayerReportByAttrQuery = function (customerId, reportType, qaCodes, gfo) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/qcInterLayerReportByAttrQuery';
            var params = {
                customerId: customerId,
                reportType: reportType
            };
            if (qaCodes) {
                params.qaCodes = JSON.stringify(qaCodes);
            }
            if (gfo) {
                params.gfo = JSON.stringify(gfo);
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp.data.sql);
            }, function (err) { return reject(err); });
        });
    };
    LayerQcService.prototype.buildFishbone = function () {
        var _this = this;
        var layer = this.layerService.layerListBS.getValue().layers.find(function (l) { return l.category && l.category.code === _this.attrIndexService.cateCodeAddress; });
        if (layer && layer.id) {
            this.qcLayers([layer.id], 'fishbone');
        }
        else {
            this.toastr.info('Address layer not found');
        }
    };
    return LayerQcService;
}());
export { LayerQcService };
